import { Traversal, type } from 'arktype';
import { endOfToday } from 'date-fns';

import { BeneficiaryType } from '@/types/customer';

const baseSchema = type({
  type: type.enumerated(...Object.values(BeneficiaryType), 'ALL'),
  fromDate: type('string'),
  toDate: type('string'),
});

type BaseSchemaType = typeof baseSchema.infer;

const validateDateRange = (data: BaseSchemaType, ctx: Traversal): boolean => {
  const toDate: Date = new Date(data.toDate);
  const today: Date = endOfToday();

  if (data.fromDate && data.toDate) {
    const fromDate: Date = new Date(data.fromDate);

    if (fromDate > toDate) {
      return ctx.reject({
        path: ['toDate'],
        message: 'TO_DATE_MUST_BE_AFTER_FROM_DATE',
      });
    }
  }

  if (data.toDate && toDate > today) {
    return ctx.reject({
      path: ['toDate'],
      message: 'TO_DATE_CANNOT_BE_AFTER_TODAY',
    });
  }

  return true;
};

export const beneficiariesFiltersSchema = baseSchema.narrow(validateDateRange);

export type BeneficiariesFiltersFormData = typeof beneficiariesFiltersSchema.infer;
